var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    x: 0,
    y: 0,
    viewBox: "0 0 6.3499999 6.3500002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.061616997868383e-16,1,1,-3.061616997868383e-16,0.00003349781036288135,-0.00003349781036288135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -290.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "m2.2580394 291.96502a.26460982.26460982 0 0 0 -.1741496.46871l1.6190225 1.38699-1.6190225 1.38648a.26460982.26460982 0 1 0 .3436483.40049l1.8536335-1.58595a.26460982.26460982 0 0 0 0-.40256l-1.8536335-1.5875a.26460982.26460982 0 0 0 -.1694987-.0667z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "rgb(0,0,0)",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "rgb(0,0,0)",
    "solid-opacity": 1,
    vectorEffect: "none",
    fill: "currentColor",
    "data-original": "#000000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.1ac188f41a69b58255e37c106566c804.svg";
export { ForwardRef as ReactComponent };